import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { CookiesProvider } from 'react-cookie';

import Container from 'react-bootstrap/Container';

import PrivateRoute from './route';
import Home from '../pages/Home';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AlterarUnidade from '../components/Header/AlterarUnidade';
import AlertaExpedicao from '../pages/AlertaExpedicao';
import AlertaExpedicaoProvider from '../pages/AlertaExpedicao/contextsAlerta/AlertaExpedicao';
import Erro from '../pages/Erro';
import AlertaPostagem from '../pages/AlertaPostagem';
import { GlobalStorage } from '../store/GlobalContext';
import { AuthStorage } from '../store/AuthContext';
import AuthCallback from '../components/Auth/AuthCallback';
import Login from '../pages/Login';
import AlertaLoec from '../pages/AlertaLoec';
import AlertaLoad from '../pages/AlertaLoad';

const RoutesApp = () => {

    return (

        <BrowserRouter>
            <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <GlobalStorage>
                <AuthStorage>
                    <AlertaExpedicaoProvider>
                        <div id="app">

                            <Header />

                            <Container fluid id='container-principal'>
                                <Routes>
                                    <Route path='/' element={<Home />} />
                                    <Route path="/auth" element={<AuthCallback />} />
                                    <Route path='/login' element={<Login />} />
                                    <Route path='/alerta-load' element={<AlertaLoad />} />
                                    <Route path='/alterar-unidade' element={<PrivateRoute><AlterarUnidade /></PrivateRoute>} />
                                    <Route path='/alerta-postagem' element={<AlertaPostagem />} />
                                    <Route path='/alerta-expedicao' element={<PrivateRoute><AlertaExpedicao /></PrivateRoute>} />
                                    <Route path='/alerta-loec' element={<PrivateRoute><AlertaLoec /></PrivateRoute>} />
                                    <Route path="/erro" element={<Erro />} />
                                    <Route path="*" element={< Navigate to='/' replace />} />
                                </Routes>
                            </Container>
                            <Footer />
                        </div>
                    </AlertaExpedicaoProvider>
                </AuthStorage>
            </GlobalStorage>
            </CookiesProvider>
        </BrowserRouter>
    )
}

export default RoutesApp